import React, { Fragment, useState, useEffect, useRef } from 'react';
import moment from 'moment';
import { Spin } from 'antd';
import cloneDeep from 'lodash.clonedeep';
// import axios from 'axios';
import { connect } from 'react-redux';
import { ErrorComponent, NoRecordComponent } from '../../../Utils';
import ReactEcharts from '../../../Echarts/Echarts';
import { getChartDataWithoutSelection, getChartWarningSelection } from '../../../ChartCalls';
import { trendLabelTranslation } from '../../../../Utils/Adapter/translationAdapter';
// import localStorage from '../../../../../../utils/localStorage';
import { WarningDashboard } from '../../../../Mock/MockJson';
// import { REPORTS } from '../../../../../../commons/api';

const SliderWarning = (props) => {
  const [option, setOption] = useState(getOption());
  // const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  // const [colors, setColors] = useState(props.graphprops.colors);
  // const [translationCache, setTranslationCache] = useState(props.translationCache || []);
  // const [language, setLanguage] = useState(props.language || 'English');
  const  setRefreshDateTime = useState(moment());
  const [reportName, setReportName] = useState('');
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  const [selectedDateRange, setSelectedDateRange] = useState({});
  
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  useEffect(() => {
    getData(props);

    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, [props]);

  useEffect(() => {
    if (
      props.graphprops !== props.graphprops ||
      props.selectionDate !== props.selectionDate ||
      props.selectionMonth !== props.selectionMonth ||
      props.selectionWeek !== props.selectionWeek ||
      props.deviceId !== props.deviceId ||
      props.shift !== props.shift ||
      props.selectionDateRange !== props.selectionDateRange ||
      props.dayMonthYear !== props.dayMonthYear ||
      props.dropdownSelection !== props.dropdownSelection
    ) {
      getData(props);
    }
  }, [props]);

  const onChartClick = (cellData) => {
    let newSelectedDateRange = { ...selectedDateRange };
    if (newSelectedDateRange && newSelectedDateRange.startDate) {
      newSelectedDateRange = {
        startDate: newSelectedDateRange.startDate,
        endDate: cellData.name
      };
      setSelectedDateRange({});
      props.sendSelectedDateRange(newSelectedDateRange);
    } else {
      newSelectedDateRange = {
        startDate: cellData.name,
        endDate: ''
      };
      setSelectedDateRange(newSelectedDateRange);
    }
  };

  const downLoadExcel = () => {
    let url = `:5000/api/reports/${reportName}`;
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', reportName); // or any other extension
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the link element
  };

  const getData = async (props) => {
    requestCheck.current = false;
    let json = [];
    let jsonWarningLimits = [];
    let { graphprops } = props;
    setLoading(true);
    let errorInAPI = false;
    let noDataInDB = false;

    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = WarningDashboard;
      requestCheck.current = true;
      setLoading(false);
    } else {
      if (
        props.graphprops.graph === 'rangeLine' &&
        props.graphprops.currentDateData !== undefined
      ) {
        json = props.graphprops.currentDateData;
      } else {
        if (
          (graphprops &&
            (graphprops.DashboardLevelSelection === 'datePicker' ||
              graphprops.GraphLevelSelection === 'datePicker') &&
            props.selectionDate) ||
          (graphprops &&
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            props.selectionMonth) ||
          (graphprops &&
            (graphprops.DashboardLevelSelection === 'weakPicker' ||
              graphprops.GraphLevelSelection === 'weakPicker') &&
            props.selectionWeek) ||
          (graphprops &&
            (graphprops.DashboardLevelSelection === 'shiftPicker' ||
              graphprops.GraphLevelSelection === 'shiftPicker') &&
            props.shift) ||
          (graphprops &&
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            props.selectionDateRange) ||
          (graphprops &&
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            props.dayMonthYear) ||
          (graphprops && graphprops.dashboardType === 'dynamic') ||
          (graphprops.dashboardType === 'dropdownHide' && props.DeviceCode) ||
          (graphprops &&
            graphprops.dashboardType === 'hierarchy' &&
            props.dropdownSelection) ||
          (graphprops && props.dashboardPayload) ||
          (graphprops && graphprops.treeExists === 'true' && props.AssetCode)
        ) {
          json = await getChartWarningSelection({
            graphprops,
            DeviceCode: props.DeviceCode,
            selectionDate: props.selectionDate,
            selectionMonth: props.selectionMonth,
            selectionWeek: props.selectionWeek,
            shift: props.shift,
            selectionDateRange: props.selectionDateRange,
            dayMonthYear: props.dayMonthYear,
            abortController: abortController.current,
            dropdownSelection: props.dropdownSelection,
            dashboardPayload: props.dashboardPayload,
            AssetCode: props.AssetCode,
            currentTimeZone: props.currentTimeZone
          });
          jsonWarningLimits = await getChartWarningSelection({
            graphprops: {
              ...graphprops,
              graph: 'table'
            },
            DeviceCode: props.DeviceCode,
            selectionDate: props.selectionDate,
            selectionMonth: props.selectionMonth,
            selectionWeek: props.selectionWeek,
            shift: props.shift,
            selectionDateRange: {
              ...props.selectionDateRange,
              warningGraphType: 'table',
              warningCondition: true
            },
            dayMonthYear: props.dayMonthYear,
            abortController: abortController.current,
            dropdownSelection: props.dropdownSelection,
            dashboardPayload: props.dashboardPayload,
            AssetCode: props.AssetCode,
            currentTimeZone: props.currentTimeZone
          });

          requestCheck.current = true;
          setLoading(false);
        } else {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            dropdownSelection: props.dropdownSelection,
            DeviceCode: props.DeviceCode,
            TimeZone: props.currentTimeZone
          });
          requestCheck.current = true;
          setLoading(false);
        }
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0) ||
      (graphprops.enableMock && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      let reportName = '';
      if (graphprops && graphprops.enableExcel) {
        // reportName = await getReportNametoDownload(
        //   defaultExcelAdapter(json)
        // );
      }

      if (json && Array.isArray(json)) {
        let dates = [];
        let values = [];
        let name = '';
        let seriesarray = [];
        let legendsdata = [];
        let tagnames = [];
        json.map((val) => {
          if (val.Name !== name && tagnames.indexOf(val.Name) === -1) {
            tagnames.push(val.Name);
            name = val.Name;
            legendsdata.push({
              name: val.Description,
              icon: 'roundRect',
              textStyle: {
                color: 'white',
                fontSize: 15,
                fontWeight: 'bold'
              }
            });
          }
          return {};
        });
        let yAxisData = [];

        if (Array.isArray(props.graphprops.YAxis)) {
          yAxisData = [...props.graphprops.YAxis];
        }

        let yaxis = yAxisData.map((value, index) => {
          let axis = {};
          axis.splitLine = {
            show: true,
            lineStyle: {
              color: '#504c4c'
            },
            axisLabel: { fontSize: 15 }
          };
          axis.triggerEvent = true;
          axis.axisLine = {
            lineStyle: {
              color:
                props.graphprops.colors[index] !== undefined
                  ? value && value.tags && value.tags.length > 1
                    ? 'white'
                    : props.graphprops.colors[index]
                  : 'white'
            },
            axisLabel: { fontSize: 15 }
          };
          axis.max = value.max;
          axis.min = value.min;
          axis.offset = value.offset;
          axis.interval = value.interval;
          axis.position = value.position;
          axis.name = value.name;
          axis.tags = value.tags;
          return axis;
        });

        yaxis.unshift({
          splitLine: {
            show: true,
            lineStyle: {
              color: '#504c4c'
            }
          },
          triggerEvent: true,
          axisLine: {
            lineStyle: {
              color: 'white'
            }
          },
          axisLabel: { fontSize: 15 },
          tags: []
        });

        tagnames.map((tagval, tagindex) => {
          values = [];
          json.map((jsonval) => {
            if (tagnames[0] === jsonval.Name && tagindex === 0) {
              let date = [];
              if (props.initialRender) {
                date =
                  graphprops && graphprops.type === 'live'
                    ? moment.utc(jsonval.DateTime).local().format('HH:mm:ss')
                    : moment(jsonval.DateTime).format('HH:mm:ss');
              } else {
                date =
                  graphprops && graphprops.type === 'live'
                    ? moment.utc(jsonval.DateTime).local().format('DD/MM/YYYY HH:mm:ss')
                    : moment(jsonval.DateTime).format('DD/MM/YYYY HH:mm:ss');
              }
              dates.push(date);
            }
            if (tagval === jsonval.Name) {
              values.push(jsonval.Value);
            }
            return {};
          });
          if (props.graphprops.linetype === 'area') {
            if (yaxis.length > 1) {
              yaxis.map((axis, axisindex) => {
                if (axis.tags.indexOf(tagval) !== -1) {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    type: 'bar',
                    axisLabel: { fontSize: 15 },
                    yAxisIndex: axisindex,
                    areaStyle: {},
                    smooth: true,
                    markPoint: {
                      data: [
                        { type: 'max', name: legendsdata[tagindex]['name'] },
                        { type: 'min', name: legendsdata[tagindex]['name'] }
                      ]
                    }
                  });
                }
                return {};
              });
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'bar',
                axisLabel: { fontSize: 15 },
                areaStyle: {},
                smooth: true,
                markPoint: {
                  data: [
                    { type: 'max', name: legendsdata[tagindex]['name'] },
                    { type: 'min', name: legendsdata[tagindex]['name'] }
                  ]
                }
              });
            }
          } else {
            if (yaxis.length > 1) {
              yaxis.map((axis, axisindex) => {
                if (axis.tags.indexOf(tagval) !== -1) {
                  seriesarray.push({
                    name: legendsdata[tagindex]['name'],
                    data: values,
                    yAxisIndex: axisindex,
                    type: 'bar',
                    axisLabel: { fontSize: 15 },
                    markPoint: {
                      data: [
                        { type: 'max', name: legendsdata[tagindex]['name'] },
                        { type: 'min', name: legendsdata[tagindex]['name'] }
                      ]
                    }
                  });
                }
                return {};
              });
            } else {
              seriesarray.push({
                name: legendsdata[tagindex]['name'],
                data: values,
                type: 'bar',
                axisLabel: { fontSize: 15 },
                markArea: {
                  data:
                    jsonWarningLimits && Array.isArray(jsonWarningLimits)
                      ? jsonWarningLimits.map((warningObject) => {
                          if (props.initialRender) {
                            return [
                              {
                                xAxis: moment
                                  .utc(warningObject.StartDate)
                                  .local()
                                  .format('HH:mm:ss'),
                                itemStyle: {
                                  color: warningObject.color
                                }
                              },
                              {
                                xAxis: moment.utc(warningObject.EndDate).local().format('HH:mm:ss')
                              }
                            ];
                          } else {
                            return [
                              {
                                xAxis: moment
                                  .utc(warningObject.StartDate)
                                  .local()
                                  .format('DD/MM/YYYY HH:mm:ss'),
                                itemStyle: {
                                  color: warningObject.color
                                }
                              },
                              {
                                xAxis: moment
                                  .utc(warningObject.EndDate)
                                  .local()
                                  .format('DD/MM/YYYY HH:mm:ss')
                              }
                            ];
                          }
                        })
                      : []
                }
              });
            }
          }
          return {};
        });
         

        const newOption = cloneDeep(getOption());
        if (props.graphprops.enableExcel) {
          // const graphContext = this;
          newOption.toolbox.feature.myTool1 = {
            show: true,
            title: 'Download Excel',
            icon: 'path:M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z',
            onclick: downLoadExcel
            };
          }
        

        let series = await trendLabelTranslation(seriesarray, props.translationCache);

        newOption.xAxis.data = dates;
        newOption.yAxis = [...yaxis];
        newOption.series = [...series];
        newOption.legend = [...legendsdata];
        newOption.color = ['steelblue'];

        setOption(newOption);
        setReportName(reportName && reportName.file ? reportName.file : '');
        setRefreshDateTime(moment());
        setErrorInAPI(errorInAPI);
        setNoDataInDB(noDataInDB);
        return newOption;
      }
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  

  const getOption = () => {
    let theme = props.selectedThemeing;

    let option = {
      legend: {
        textStyle: { color: theme === 'lightTheme' ? 'black' : 'white' },
        data: [
          {
            name: 'test1',
            icon: 'roundRect',
            textStyle: {
              fontSize: 15
            }
          }
        ]
      },
      tooltip: {
        trigger: 'axis',
        textStyle: {
          fontSize: 15
        }
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            title: 'Download',
            name: props.graphprops.title,
            backgroundColor: theme !== 'lightTheme' ? 'black' : 'white',
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        },
        grid: {
          left: '5%',
          right: '15%',
          bottom: '10%'
        },
        tooltip: {
          show: true,
          backgroundColor: '#222',
          textStyle: {
            fontSize: 12
          },
          extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);'
        }
      },
      xAxis: {
        type: 'category',
        data: props.graphprops.xaxisLabels,
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisTick: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        axisLabel: {
          color: theme === 'lightTheme' ? 'black' : 'white',
          fontSize: 15
        }
      },
      yAxis: {
        type: 'value',
        axisLine: {
          lineStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        }
      },
      dataZoom: [
        {
          type: 'slider',
          show: true,
          start: 0,
          end: 100,
          backgroundColor: '#9a9191',
          textStyle: {
            color: theme === 'lightTheme' ? 'black' : 'white'
          }
        },
        {
          type: 'inside',
          start: 0,
          end: 100
        }
      ],
      grid: {
        top: '30%'
      }
    };
    return option;
  };

  const theme = props.selectedThemeing;

  return (
    <Fragment>
      {noDataInDB === true || errorInAPI === true ? (
        noDataInDB === true ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {loading === false ? (
            <ReactEcharts
              option={option}
              notMerge={true}
              lazyUpdate={true}
              onEvents={{
                click: (cellData) => onChartClick(cellData)
              }}
              className="react_for_echarts"
            />
          ) : (
            <div
              style={{
                textAlign: 'center',
                color: theme === 'lightTheme' ? 'black' : 'white',
                marginTop: '10%'
              }}
            >
              <h2 style={{ color: 'white' }}>
                <Spin spinning={loading} tip="Loading..." ></Spin>
              </h2>
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.translationCache
  };
};

export default connect(mapStateToProps)(SliderWarning);